const PopUpBody = ({ children }) => {
  return (
    <div className="font-chinese min-w-[40vw] grid grid-cols-[repeat(2,min-content_1fr)] gap-y-2 gap-x-2 p-4 whitespace-nowrap items-center">
      {children}
    </div>
  );
};

export default PopUpBody;
